export const CERTIFICATION_EXPIRING_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

export const CERTIFICATION_STATUS = Object.freeze({
  ACTIVE: 'Active',
  EXPIRING: 'Expiring',
  EXPIRED: 'Expired',
  ARCHIVED: 'Archived'
});

export function classifyCertification(document, now = Date.now()) {
  if (document?.archivedAt) return CERTIFICATION_STATUS.ARCHIVED;
  if (!document?.expiresAt) return CERTIFICATION_STATUS.ACTIVE;
  const expiration = new Date(document.expiresAt).getTime();
  const reference = now instanceof Date ? now.getTime() : Number(now);
  if (Number.isNaN(expiration) || !Number.isFinite(reference)) return CERTIFICATION_STATUS.ACTIVE;
  if (expiration < reference) return CERTIFICATION_STATUS.EXPIRED;
  if (expiration - reference <= CERTIFICATION_EXPIRING_WINDOW_MS) return CERTIFICATION_STATUS.EXPIRING;
  return CERTIFICATION_STATUS.ACTIVE;
}

export function certificationName(document) {
  return document?.title || document?.fileName || 'Certification record';
}
